import { createAppRouter } from './generateRoutes'

const router = createAppRouter()

export default router
